import Logo from './Logo.png';

import NotFound from "./ImgNotFound.png";
import Manhattan from "./panini/manhattan.jpg";
import Monterey from "./panini/monterey.jpg";
import Smash from "./panini/smash.jpg";
import Newsmash from "./panini/newsmash.jpg";
import Washington from "./panini/washington.jpg";
import Boston from "./panini/boston.jpg";
import Chef from "./panini/chef.jpg";
import Chef2 from "./panini/chef2.0.jpg";
import Colorado from "./panini/colorado.jpg";
import Lasvegas from "./panini/lasvegas.jpg";
import Losangeles from "./panini/losangeles.jpg";
import Louisiana from "./panini/louisiana.jpg";
import Seattle from "./panini/seattle.jpg";
import Philadelphia from "./panini/philadelphia.jpg";
import Neworleans from "./panini/neworleans.jpg";
import Cincinnati from "./panini/cincinnati.jpg";
import Denver from "./panini/denver.jpg";
import Massachusset from "./panini/massachusset.jpg";
import Miami from "./panini/miami.jpg";
import Orlando from "./panini/orlando.jpg";
import Portland from "./panini/portland.jpg";
import Sandiego from "./panini/sandiego.jpg";
import Sanfrancisco from "./panini/sanfrancisco.jpg";
import Santabrarbara from "./panini/santabrarbara.jpg";
import Texas from "./panini/texas.jpg";

import Entrecote from "./carni/entrecote.jpg";
import Filetto from "./carni/filetto.jpg";
import HamburgerDiGrana from "./carni/hamburgerdigrana.jpg";
import HamburgerMarchig from "./carni/hamburgermarchig.jpg";
import Pulledpork from "./carni/pulledpork.jpg";
import Tagliata from "./carni/tagliata.jpg";

const images =  {
    Logo,
    Manhattan,
    Monterey,
    Newsmash,
    Smash,
    Washington,
    Boston,
    Chef,
    Chef2 ,
    Colorado,
    Lasvegas,
    Losangeles ,
    Louisiana ,
    Seattle,
    Philadelphia,
    Neworleans,
    Cincinnati,
    Denver,
    Massachusset, 
    Miami,
    Orlando, 
    Portland,
    Sandiego,
    Sanfrancisco, 
    Santabrarbara,
    Texas,
    Entrecote,
    Filetto,
    HamburgerDiGrana,
    HamburgerMarchig,
    Pulledpork,
    Tagliata,
    NotFound
}


export default images;